<img *ngIf="imageUrl" [ngStyle]="style" class="rounded-image" [src]="imageUrl">